export { default as SplashInputEntityIcon } from "./SplashInputEntity";
export { default as SplashProjectIcon } from "./SplashProject";
export { default as TempIcon } from "./Temp";
export { default as LoadingIcon } from "./Loading";
export { AboutIcon } from "./AboutIcon";

export { default as DATA_TYPES_ICONS } from "./DataTypesIcons";
